import React from 'react';
import PDFComp from './PDFComp';

export default function Terms() {
    
  return (
    <div>
        <h1 className='text-center display-4'>Terms and conditions</h1>
       <PDFComp />
    </div>
  )
}
